import React, { useCallback, useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { PersonExtended } from '@sdir/httpclient/lib/clients/core/externallookup';
import { useAuthenticatedCheck, useCurrentUser } from '@sdir/auth/lib/hooks';
import { Loadable } from '../../../types';
import { commonAddresseePersonApi, fregApi } from '../../../httpclient';
import {
  CurrentRegisteredPersonContext,
  ICurrentRegisteredPersonContext,
} from '../../../services/contexts/CurrentRegisteredPersonContext';
import { useCurrentUserInfo } from '../../../services/hooks/useCurrentUserInfo';

export const CurrentRegisteredPersonProvider: React.FC<{ children: any }> = ({ children }) => {
  const { isAuthenticated } = useAuthenticatedCheck(false);

  const {
    userInfo: { isOrganization, isExternal },
  } = useCurrentUserInfo();

  const currentUser = useCurrentUser();

  const [currentPerson, setPerson] = useState<Loadable<PersonExtended>>({});

  const loadPerson = useCallback(async () => {
    setPerson({ loading: true });
    if (isExternal) {
      commonAddresseePersonApi
        .v1PersonGetpersonbyusernameUsernameGet(currentUser?.profile?.name || '')
        .then((response) => {
          const person = response?.data;
          if (!person) {
            throw new Error('Correct user could not be found');
          }
          setPerson({
            result: {
              firstName: person?.firstname,
              lastName: person?.lastname,
              middleName: person?.middlename,
              birthdate: person?.birthDate,
              personNumber: person?.personalIdentityNumber,
              personNumbers: [person?.personalIdentityNumber],
            } as PersonExtended,
          });
        })
        .catch((error) => {
          setPerson({ error });
        });
    } else {
      fregApi
        .v2FregGetownpersonGet()
        .then((response: AxiosResponse<PersonExtended>) => {
          if (!response?.data) throw new Error('Correct user could not be found');
          setPerson({ result: response.data });
        })
        .catch((error) => {
          setPerson({ error });
        });
    }
  }, [currentUser?.profile, isExternal]);

  useEffect(() => {
    if (isAuthenticated && !isOrganization) {
      loadPerson();
    }
  }, [isAuthenticated, isOrganization]);

  const value: ICurrentRegisteredPersonContext = {
    person: currentPerson,
    refresh: loadPerson,
  };

  return (
    <CurrentRegisteredPersonContext.Provider value={value}>
      {children}
    </CurrentRegisteredPersonContext.Provider>
  );
};
